module.exports = __webpack_public_path__ + "static/media/eye.6bc1630e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eye.svg
// module id = 257
// module chunks = 0